import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		ErrorComponent,
	],
	imports: [
		CommonModule,
		IonicModule,
	],
	exports: [
		ErrorComponent,
	]
})
export class ErrorComponentModule {
	constructor() {

	}
}
